import React from 'react';
import PropTypes from 'prop-types';
import { Content } from '@tekion/tmatter';
import { EMPTY_STRING } from '@tekion/tekion-base/app.constants';
var NoteText = function NoteText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(Content, {
    className: "inline note__text"
  }, children);
};
NoteText.propTypes = {
  children: PropTypes.string
};
NoteText.defaultProps = {
  children: EMPTY_STRING
};
export default NoteText;